import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { Animation } from '@shared/enums/animation';

@Component({
  selector: 'app-animation',
  templateUrl: './animation.component.html',
  styleUrls: ['./animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimationComponent extends ComponentAbstract implements OnInit {
  options: AnimationOptions;

  @Input() animationItem: Animation = Animation.WHITE_LOGO;
  @Input() attrWidth = '200px';
  @Input() attrHeight = '200px';
  @Input() loop = true;

  constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit(): void {
    this.options = this.getConfig();
  }

  private getConfig(): AnimationOptions {
    return { loop: this.loop, path: this.getConfigPath() };
  }

  private getConfigPath(): string {
    const configPath = '../../../../../assets/animations/';
    switch (this.animationItem) {
      case Animation.WHITE_LOGO: {
        return `${configPath}logo_white.json`;
      }
      case Animation.BLACK_LOGO: {
        return `${configPath}logo_black.json`;
      }
    }
  }
}
